import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import PrivacyPolicyPage from '../components/company/privacy-policy/privacy-policy';

const PrivacyPolicyRoute = () => (
  <Fragment>
    <DocumentTitle title="Privacy Policy | NerdWallet" />
    <PrivacyPolicyPage />
  </Fragment>
);

PrivacyPolicyRoute.displayName = 'PrivacyPolicyRoute';
PrivacyPolicyRoute.analyticsName = 'privacypolicy_page';
PrivacyPolicyRoute.segmentPageName = 'privacy_policy';

export default PrivacyPolicyRoute;
